import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col h-full gap-6 p-4 pt-20 overflow-y-auto xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-1" };
const _hoisted_3 = { class: "text-2xl font-bold text-gray-900" };
const _hoisted_4 = { class: "text-sm text-gray-500" };
const _hoisted_5 = { class: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" };
const _hoisted_6 = { class: "flex flex-wrap items-center gap-1" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "flex flex-wrap items-center gap-3" };
const _hoisted_9 = {
    key: 0,
    class: "w-2 h-2 rounded-full bg-eorange-500 ml-0.5"
};
const _hoisted_10 = {
    key: 0,
    class: "flex flex-col items-center justify-center py-16"
};
const _hoisted_11 = { class: "mt-3 text-sm text-gray-500" };
const _hoisted_12 = {
    key: 1,
    class: "flex flex-col items-center justify-center py-16 bg-gray-50 rounded-xl"
};
const _hoisted_13 = { class: "flex items-center justify-center w-20 h-20 mb-4 bg-gray-100 rounded-full" };
const _hoisted_14 = { class: "text-sm text-gray-500" };
const _hoisted_15 = {
    key: 2,
    class: "flex flex-col gap-3"
};
const _hoisted_16 = ["disabled"];
import { ref, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { IconAdjustmentsHorizontal, IconCalendarOff, } from "@tabler/icons-vue";
import { useOverlay } from "@/services/overlay-service";
import { createSidebarConfig } from "@/utils/overlay-utils";
import { useReservations } from "@/domains/reservations/composables";
import { reservationService } from "@/domains/reservations/services";
import { BookingCard, BookingDetailDrawer, FiltersPopover, } from "@/domains/reservations/components";
import { useServiceStore } from "@/domains/service/stores/service.store";
// ---------------------------------------------------------------------------
// Composable
// ---------------------------------------------------------------------------
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReservationsIndex',
    setup(__props) {
        const { t } = useI18n();
        const { items, hasMore, isLoading, isLoadingMore, applyTab, setService, clearFilters, loadMore, } = useReservations({ autoLoad: true });
        // ---------------------------------------------------------------------------
        // Tabs
        // ---------------------------------------------------------------------------
        const tabs = reservationService.RESERVATION_TABS;
        const activeTabId = ref("ALL");
        async function handleTabClick(tabId) {
            activeTabId.value = tabId;
            await applyTab(tabId);
        }
        // ---------------------------------------------------------------------------
        // Filters Popover
        // ---------------------------------------------------------------------------
        const showFiltersPopover = ref(false);
        const filtersAnchorRef = ref(null);
        const popoverFilters = ref({
            serviceId: null,
        });
        const hasActivePopoverFilters = computed(() => popoverFilters.value.serviceId !== null);
        async function handleApplyFilters(val) {
            await setService(val.serviceId);
        }
        async function handleClearFilters() {
            popoverFilters.value = { serviceId: null };
            activeTabId.value = "ALL";
            await clearFilters();
        }
        // ---------------------------------------------------------------------------
        // Available services (for the filter dropdown)
        // ---------------------------------------------------------------------------
        const serviceStore = useServiceStore();
        onMounted(() => {
            serviceStore.fetchServices();
        });
        const availableServices = computed(() => serviceStore.services.map((service) => ({ id: service.id, name: service.name })));
        // ---------------------------------------------------------------------------
        // Detail Drawer
        // ---------------------------------------------------------------------------
        const overlay = useOverlay();
        function openDetailDrawer(booking) {
            overlay.open(createSidebarConfig({
                component: BookingDetailDrawer,
                props: { booking },
                closeOnBackdrop: true,
                events: {
                    close: () => overlay.closeTop(),
                },
            }));
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("reservations.auto.reservas")), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("reservations.auto.gestiona_todas_las_reservas_de_tus_servicios")), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: tab.id,
                                type: "button",
                                class: _normalizeClass(["px-4 py-2 text-sm font-medium transition-colors rounded-full",
                                    activeTabId.value === tab.id
                                        ? 'bg-eorange-500 text-white'
                                        : 'text-gray-500 hover:bg-gray-100'
                                ]),
                                onClick: ($event) => (handleTabClick(tab.id))
                            }, _toDisplayString(_unref(t)(tab.labelKey)), 11, _hoisted_7));
                        }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                            class: "relative",
                            ref_key: "filtersAnchorRef",
                            ref: filtersAnchorRef
                        }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-gray-200 bg-white text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors",
                                onClick: _cache[0] || (_cache[0] = ($event) => (showFiltersPopover.value = !showFiltersPopover.value))
                            }, [
                                _createVNode(_unref(IconAdjustmentsHorizontal), { class: "w-4 h-4" }),
                                _createTextVNode(_toDisplayString(_ctx.$t("reservations.auto.mas_filtros")), 1),
                                (hasActivePopoverFilters.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                                    : _createCommentVNode("", true)
                            ]),
                            (showFiltersPopover.value)
                                ? (_openBlock(), _createBlock(_unref(FiltersPopover), {
                                    key: 0,
                                    services: availableServices.value,
                                    "model-value": popoverFilters.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (popoverFilters.value = $event)),
                                    onApply: handleApplyFilters,
                                    onClear: handleClearFilters,
                                    onClose: _cache[2] || (_cache[2] = ($event) => (showFiltersPopover.value = false))
                                }, null, 8, ["services", "model-value"]))
                                : _createCommentVNode("", true)
                        ], 512)
                    ])
                ]),
                (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-8 h-8 border-2 rounded-full border-eorange-500 border-t-transparent reservas-spinner" }, null, -1)),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("reservations.auto.cargando_reservas")), 1)
                    ]))
                    : (_unref(items).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_unref(IconCalendarOff), { class: "w-10 h-10 text-gray-400" })
                            ]),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("reservations.auto.no_se_encontraron_reservas")), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (booking) => {
                                return (_openBlock(), _createBlock(_unref(BookingCard), {
                                    key: booking.id,
                                    booking: booking,
                                    onViewDetails: openDetailDrawer
                                }, null, 8, ["booking"]));
                            }), 128)),
                            (_unref(hasMore))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "mx-auto inline-flex items-center h-9 px-4 mt-2 text-sm font-medium transition-colors bg-white border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-60",
                                    "data-test": "reservations-load-more",
                                    disabled: _unref(isLoadingMore),
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_unref(loadMore) && _unref(loadMore)(...args)))
                                }, _toDisplayString(_unref(isLoadingMore)
                                    ? _ctx.$t("reservations.auto.cargando_mas")
                                    : _ctx.$t("reservations.auto.cargar_mas")), 9, _hoisted_16))
                                : _createCommentVNode("", true)
                        ]))
            ]));
        };
    }
});
